module.exports = __webpack_public_path__ + "img/fblc-92赛区.f0c64baf.jpg";